
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/university/[slug]/[universityId]",
      function () {
        return require("private-next-pages/university/[slug]/[universityId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/university/[slug]/[universityId]"])
      });
    }
  